import { updateDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../config';

/**
 * ファイル出力履歴のファイル名を更新
 */
export const updateFileExportHistoryFileName = async (
  id: string,
  fileName: string,
): Promise<void> => {
  const fileExportHistoryDocRef = doc(db, 'fileExportHistory', id);
  await updateDoc(fileExportHistoryDocRef, {
    file_name: fileName,
    updated_at: serverTimestamp(),
  });
};
